// extracted by mini-css-extract-plugin
export default {"form":"default_form__m9dry","content":"default_content__4yuby","control":"default_control__MTTBQ","submit":"default_submit__jaCir"};